export interface ILateSerology {
    donorAlias: string,
    surgeryDate: string,
    uploadBy: string,
    receivedVrl: string,
    uploadDate: string,
    daysLate: string
}